// the store language: labels from f5-head (window.F5T) and the locale root, so arabic pages fetch arabic sections
var F5T = window.F5T || {};
var F5R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
(function () {
  'use strict';

  var DRAWER = 'ef-cart-drawer';
  var PREFIX = 'shopify-section-';
  var busy = false;

  function dlg() { return document.getElementById('EfCart'); }
  function err(msg) {
    var el = document.querySelector('[data-cart-err]');
    if (el) el.textContent = msg || '';
  }

  function hostOf(el) {
    if (!el || !el.closest) return null;
    return el.closest('[id^="' + PREFIX + '"]');
  }

  function sectionIdOf(el) {
    var host = hostOf(el);
    return host ? host.id.slice(PREFIX.length) : null;
  }

  function pageHost() { return hostOf(document.querySelector('[data-cart-page]')); }

  function sectionList() {
    var ids = [DRAWER];
    var host = pageHost();
    if (host) ids.push(host.id.slice(PREFIX.length));
    return ids.join(',');
  }

  function open() {
    var d = dlg();
    if (!d || d.open) return;
    d.removeAttribute('closing');
    d.showModal();
  }

  function close() {
    var d = dlg();
    if (!d || !d.open) return;
    d.setAttribute('closing', '');

    var done = function () {
      d.removeAttribute('closing');
      if (d.open) d.close();
    };
    var guard = setTimeout(done, 600);

    d.addEventListener('transitionend', function onEnd(e) {
      if (e.target !== d) return;
      clearTimeout(guard);
      d.removeEventListener('transitionend', onEnd);
      done();
    });
  }

  function roleOf(el) {
    if (el.classList.contains('f-cart__rm')) return 'rm';
    return el.previousElementSibling ? 'inc' : 'dec';
  }

  function focusKey() {
    var el = document.activeElement;
    if (!el || !el.closest) return null;
    var btn = el.closest('[data-cart-qty]');
    
    if (!btn) return null;
    return {
      line: btn.getAttribute('data-line'),
      role: roleOf(btn),
      inDrawer: !!btn.closest('#EfCart')
    };
  }

  function restoreFocus(key) {
    if (!key) return;
    var scope = key.inDrawer ? dlg() : document;
    if (!scope) return;

    var same = scope.querySelectorAll('[data-cart-qty][data-line="' + key.line + '"]');
    var target = null;

    for (var i = 0; i < same.length; i++) {
      if (roleOf(same[i]) === key.role) { target = same[i]; break; }
    }
    if (!target && same.length) target = same[0];

    if (!target) {
      target =
        scope.querySelector('[data-cart-qty]') ||
        scope.querySelector('[data-cart-cta]') ||
        (key.inDrawer ? scope.querySelector('[data-cart-close]') : null);
    }

    if (target && target.focus) target.focus();
  }

  function swapDrawer(html) {
    var d = dlg();
    if (!d || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('.f-cart__in');
    var live = d.querySelector('.f-cart__in');
    if (fresh && live) live.replaceWith(fresh);
  }

  function swapPage(host, html) {
    if (!host || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    
    var fresh = tmp.firstElementChild;
    if (fresh) host.replaceWith(fresh);
  }

  function applySections(data) {
    if (!data || !data.sections) return;
    swapDrawer(data.sections[DRAWER]);

    var host = pageHost();
    if (host) {
      var id = host.id.slice(PREFIX.length);
      if (data.sections[id]) swapPage(host, data.sections[id]);
    }
  }

  function setBusy(on) {
    busy = on;
    var d = dlg();
    if (d) d.classList.toggle('is-busy', on);
    var p = document.querySelector('[data-cart-page]');
    if (p) p.classList.toggle('is-busy', on);
  }

  function change(line, qty) {
    if (busy) return;
    setBusy(true);
    err('');

    var key = focusKey();

    fetch(F5R + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: sectionList() })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          err(res.j.description || res.j.message || F5T.errUpdate);
          return;
        }
        applySections(res.j);
        restoreFocus(key);
      })
      .catch(function () { err(F5T.errUpdate); })
      .finally(function () { setBusy(false); });
  }

  function add(form) {
    if (busy) return;
    setBusy(true);
    err('');

    var body = new FormData(form);
    body.append('sections', sectionList());

    fetch(F5R + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          
          err(res.j.description || res.j.message || F5T.errAdd);
          open();
          return;
        }
        applySections(res.j);
        if (form.hasAttribute('data-quiet')) {
          form.dispatchEvent(new CustomEvent('ef:cart:added', { bubbles: true }));
          return;
        }
        open();
      })
      .catch(function () { err(F5T.errAdd); })
      .finally(function () { setBusy(false); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    if (t.closest('[data-cart-close]')) { close(); return; }

    var step = t.closest('[data-cart-qty]');
    if (step) {
      e.preventDefault();
      
      if (step.disabled || step.getAttribute('aria-disabled') === 'true') return;
      change(parseInt(step.getAttribute('data-line'), 10), parseInt(step.getAttribute('data-qty'), 10));
      return;
    }

    if (t.closest('[data-cart-open]')) { e.preventDefault(); open(); return; }

    var bag = t.closest('a[href$="/cart"]');
    if (
      bag &&
      !bag.closest('#EfCart') &&
      dlg() &&
      e.button === 0 &&
      !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey
    ) {
      e.preventDefault();
      open();
      return;
    }

    var d = dlg();
    if (d && d.open && t === d) close();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    
    if (form.closest('product-form-component')) return;
    e.preventDefault();
    add(form);
  }, true);

  document.addEventListener('cancel', function (e) {
    var d = dlg();
    if (d && e.target === d) { e.preventDefault(); close(); }
  });

  document.addEventListener('ef:cart:open', open);
  document.addEventListener('ef:cart:refresh', function () {
    fetch(F5R + '?sections=' + sectionList())
      .then(function (r) { return r.json(); })
      .then(function (s) { applySections({ sections: s }); })
      .catch(function () {});
  });
})();